var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53575e",
    d: "M13.222 9.3h-2.333a.744.744 0 0 0-.778.7v2.1a.744.744 0 0 0 .778.7h2.333a.744.744 0 0 0 .778-.7V10a.744.744 0 0 0-.778-.7zm-.111-6.6v.7H6.889v-.7a.744.744 0 0 0-.778-.7.744.744 0 0 0-.778.7v.7h-.777a1.476 1.476 0 0 0-1.548 1.4L3 14.6A1.483 1.483 0 0 0 4.556 16h10.888A1.488 1.488 0 0 0 17 14.6V4.8a1.488 1.488 0 0 0-1.556-1.4h-.778v-.7a.782.782 0 0 0-1.556 0zm1.556 11.9H5.333a.744.744 0 0 1-.778-.7v-7h10.889v7a.744.744 0 0 1-.777.7z",
    transform: "translate(-3 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.455d4243.svg";
export { ForwardRef as ReactComponent };